import { logos } from "../../data/siteContent";

export const LogoMarquee = () => (
  <section className="logo-section" data-testid="logos-section">
    <div className="logo-heading" data-testid="logos-heading">
      <span className="logo-kicker" data-testid="logos-kicker">
        Real clients, real trust
      </span>
      <h2 data-testid="logos-title">Brands and professionals we have worked with</h2>
    </div>
    <div className="logo-marquee" data-testid="logo-marquee">
      <div className="logo-track" data-testid="logo-track">
        {logos.concat(logos).map((src, index) => (
          <div className="logo-item" key={`${src}-${index}`} data-testid={`logo-item-${index}`}>
            <img
              src={src}
              alt={`Client logo ${index + 1}`}
              data-testid={`logo-image-${index}`}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);
